export default __webpack_public_path__ + "static/media/arrow-right-disabled.6fd58776.svg";